export const SET_UNIT_SITE_EXCLUSION_ENABLED = 'SET_UNIT_SITE_EXCLUSION_ENABLED';
export const SET_CREATIVE_WEIGHTING_ENABLED = 'SET_CREATIVE_WEIGHTING_ENABLED';
export const SET_MARKET_TARGETING_ENABLED = 'SET_MARKET_TARGETING_ENABLED';
